import { FEATURE_VALUE_MNG } from '@/api/apiModules'
import lang from '@/lang'
export default {
  viewType: 'form',
  module: FEATURE_VALUE_MNG,
  params: null,
  view: {
    title: '创建功能价值',
    labelPosition: 'right',
    content: [
      {
        $id: 'featureValue',
        $type: 'input',
        label: '功能价值',
        rules: [
          {
            notEmpty: '功能价值'
          },
          [
            {
              max: 24,
              message: lang.t('sk.form.common_term_maxlength_valid', {
                max: 24
              })
            }
          ]
        ]
      },
      {
        $id: 'valueDesc',
        $type: 'input',
        label: '功能价值说明',
        $el: {
          type: 'textarea',
          rows: 5
        }
      }
    ]
  }
}
